/* eslint-disable func-names */
import {
  DOCUMENT_LIST,
  DOCUMENT_CREATE,
  GET_DOCUSIGN,
  DOCUMENT_TYPES,
  GET_DOC_SIGNED_URL
} from './types';

import { actionForState } from '../../../utils/helpers';

const INITIAL_STATE = {
  fetchAction: {
    success: false,
    error: false,
    loading: false
  },
  createDocumentAction: {
    success: false,
    error: false,
    loading: false
  },
  getDocusignAction: {
    loading: false,
    success: false,
    error: false
  },
  documentTypes: [],
  getDocUrlAction: {
    loading: false,
    success: false,
    error: false
  },
  docSignUrlData: []
};


export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case DOCUMENT_LIST.pending:
      return {
        ...state,
        fetchAction: actionForState(state.action, 'pending')
      };
    case DOCUMENT_LIST.success:
      return {
        ...state,
        fetchAction: actionForState(state.action, 'success'),
        documentList: action.payload
      };
    case DOCUMENT_LIST.error:
      return {
        ...state,
        fetchAction: actionForState(state.action, 'error')
      };
    case DOCUMENT_TYPES.pending:
      return {
        ...state,
        fetchAction: actionForState(state.action, 'pending')
      };
    case DOCUMENT_TYPES.success:
      return {
        ...state,
        fetchAction: actionForState(state.action, 'success'),
        documentTypes: action.payload
      };
    case DOCUMENT_TYPES.error:
      return {
        ...state,
        fetchAction: actionForState(state.action, 'error')
      };
    case DOCUMENT_CREATE.pending:
      return {
        ...state,
        createDocumentAction: actionForState(state.action, 'pending')
      };
    case DOCUMENT_CREATE.success:
      return {
        ...state,
        createDocumentAction: actionForState(state.action, 'success')
      };
    case DOCUMENT_CREATE.error:
      return {
        ...state,
        createDocumentAction: actionForState(state.action, 'error')
      };
    case GET_DOCUSIGN.pending:
      return {
        ...state,
        getDocusignAction: actionForState(state.action, 'pending')
      };
    case GET_DOCUSIGN.success:
      return {
        ...state,
        getDocusignAction: actionForState(state.action, 'success'),
        docusignData: action.payload
      };
    case GET_DOCUSIGN.error:
      return {
        ...state,
        getDocusignAction: actionForState(state.action, 'error')
      };
    case GET_DOC_SIGNED_URL.pending:
      return {
        ...state,
        getDocUrlAction: actionForState(state.action, 'pending')
      };
    case GET_DOC_SIGNED_URL.success:
      return {
        ...state,
        getDocUrlAction: actionForState(state.action, 'success'),
        docSignUrlData: action.payload
      };
    case GET_DOC_SIGNED_URL.error:
      return {
        ...state,
        getDocUrlAction: actionForState(state.action, 'error')
      };
    default:
      return state;
  }
}
